module.exports = __webpack_public_path__ + "img/lunch-launch-logo.1951b56c.png";